function SquareIcon() {
  return <div className="size-4 rounded border-[1.5px] sm:border-[2px] border-foreground/50" />;
}

function PortraitIcon() {
  return <div className="w-3 h-5 rounded border-[1.5px] sm:border-[2px] border-foreground/50" />;
}

function LandscapeIcon() {
  return <div className="w-5 h-3 rounded border-[1.5px] sm:border-[2px] border-foreground/50" />;
}

export { SquareIcon, PortraitIcon, LandscapeIcon };
